// class RatesProviderStore {
//   constructor() {
//     this.snapshot = {};
//   }

//   setSnapshot(snapshot) {
//     this.snapshot = snapshot;
//   }

//   /**
//    *
//    * @returns {GlobalState}
//    */
//   getSnapshot() {
//     return this.snapshot;
//   }
// }

import {RatesProviderStoreInstance as RatesProviderStore} from "shared-library";

export default RatesProviderStore;
